import React, { useEffect } from "react";
import FormComponent from "./form-component";
import BannerComponent from "./banner";
import KnowMoreElligibiltyComponent from "./knowmore-elligibility";
import PlacementSalaryComponent from "./placement-salary";
import AboutComponent from "./about-program";
import ProgramHighlightComponent from "./program-highhlight";
import EarnLearnComponent from "./earn-while-learn";
import ProgramFeesSelectionProcessComponent from "./program-fees-selection-process";
import AboutManipalComponent from "./about-manipal";
import FAQComponent from "./faq";

const PageMainContent = () => {
  useEffect(() => {
    window.gtag("event", "conversion", {
      send_to: "AW-10917910622/B8HRCIPuotwYEN6wiNYo",
    });
    window.fbq("init", "{1584375811875352}");
    window.fbq("track", "PO-LP");
  }, []);

  return (
    <>
      <BannerComponent></BannerComponent>
      <KnowMoreElligibiltyComponent></KnowMoreElligibiltyComponent>
      <PlacementSalaryComponent></PlacementSalaryComponent>
      <AboutComponent></AboutComponent>
      <ProgramHighlightComponent></ProgramHighlightComponent>
      {/* <EarnLearnComponent></EarnLearnComponent> */}
      <ProgramFeesSelectionProcessComponent></ProgramFeesSelectionProcessComponent>
      {/* <AboutManipalComponent></AboutManipalComponent> */}
      <FAQComponent></FAQComponent>
    </>
  );
};

export default PageMainContent;
